import { render } from "./MetricEdit.vue?vue&type=template&id=5a90a33c&ts=true"
import script from "./MetricEdit.vue?vue&type=script&lang=ts"
export * from "./MetricEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__